function webpackEmptyContext(req) {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
}
webpackEmptyContext.keys = () => ([]);
webpackEmptyContext.resolve = webpackEmptyContext;
webpackEmptyContext.id = "../../plugins sync recursive ^\\.\\/[^/]+\\/admin\\/plugin-manifest\\.js$";
module.exports = webpackEmptyContext;